module.exports = __webpack_public_path__ + "img/icon-tri-salesanalytics.b2d7094c.png";